import React from 'react';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import usePlayfulTeacher from '@/hooks/usePlayfulTeacher';
import LiveClassesDefault from './Default';
import LiveClassesPlayful from './Playful';
import LiveClassesPlayfulTeacher from './PlayfulTeacher';
import ViewLiveClass from './ViewLiveClass';

function LiveClasses(props) {
  const isPlayfulStudentTheme = usePlayfulStudent();
  const isPlayfulTeacherTheme = usePlayfulTeacher();

  if (isPlayfulStudentTheme) return <LiveClassesPlayful {...props} />;
  if (isPlayfulTeacherTheme) return <LiveClassesPlayfulTeacher {...props} />;
  return <LiveClassesDefault {...props} />;
}

export { LiveClasses, ViewLiveClass };
